var Bavaria = "Baviera";
var Berlin = "Berlino";
var Brandenburg = "Brandeburgo";
var Bremen = "Bremen";
var Hamburg = "Amburgo";
var Hesse = "Assia";
var Saarland = "Saarland";
var Saxony = "Sassonia";
var Thuringia = "Turingia";
var DEStates = {
	"Baden-Wuerttemberg": "Baden-Württemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Meclemburgo-Pomerania Anteriore",
	"Lower Saxony": "Bassa Sassonia",
	"North Rhine-Westphalia": "Renania settentrionale-Westfalia",
	"Rhineland-Palatinate": "Renania-Palatinato",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Sassonia-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
